import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = (theme) => ({
  container: {
    width: 720,
    margin: '0 auto',
    marginTop: theme.spacing(8)
  },
  personLabel: {
    display: 'inline',
    marginRight: theme.spacing(2)
  },
  collapsibleContainer: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: theme.spacing(8),
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners,
    paddingBottom: theme.spacing(7)
  },
  cardFooter: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: theme.spacing(4, 8),
    borderTop: `1px solid ${theme.colorPalette.beige_50}`,
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, { borderTop: `1px solid ${theme.colors.card_divider}` })
  },
  showHideButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  innerCardcontainer: {
    backgroundColor: theme.colors.card_background_primary_editable,
    padding: theme.spacing(8),
    borderBottomRightRadius: theme.sizes.roundCorners,
    borderBottomLeftRadius: theme.sizes.roundCorners
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4)
  },
  buttons: {
    padding: theme.spacing(0, 3)
  },
  warning: {
    marginTop: 0,
    marginBottom: 0,
    boxShadow: 'none'
  },
  driverHint: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    fontSize: '14px',
    color: theme.colorPalette.green_100
  },
  infoIcon: {
    height: '16px',
    width: '16px',
    marginRight: theme.spacing(1),
    color: theme.colorPalette.green_100,
    filter: `drop-shadow(0 0 0.5px ${theme.colorPalette.green_90})`,
    alignSelf: 'flex-start'
  },
  addDriverLink: {
    color: theme.colorPalette.orange_75,
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer'
    },
    ...reskinStyles(theme, {
      color: theme.colors.action_text,
      '&:hover': { cursor: 'pointer', textDecorationThickness: '2px' }
    })
  }
});

export default makeStyles(useStyles);
